@let userInfo = userInfo$ | async;
@let isMobile = deviceDetectionService.isMobile$ | async;
@let userAccount = userAccount$ | async;

<lib-icon-button
  #mainMenuTrigger="libDropdownTrigger"
  class="header__burger-button"
  [icon]="mainMenuTrigger.isOpen ? 'close-square' : 'menu'"
  [libDropdownTrigger]="mobileMenu"
  [isGlobal]="true"
  size="32"
>
</lib-icon-button>

@if (isMobile && userInfo) {
  <button
    #accountTrigger="libDropdownTrigger"
    type="button"
    class="header__account-block"
    [libDropdownTrigger]="accountMenu"
    [isGlobal]="true"
  >
    <span class="header__account-caption">
      {{ 'header.account' | translate }}
    </span>
    <span class="header__account-value">
      <span class="header__account-name">
        {{ userAccount?.label || ('header.buttons.all-accounts' | translate) }}
      </span>
      <lib-svg-icon
        size="12"
        [icon]="accountTrigger.isOpen ? 'arrow-up' : 'arrow-down'"
      />
    </span>
  </button>
}

<div class="header__left-wrapper">
  <img
    ngSrc="assets/images/logo-sm.png"
    priority="high"
    alt="RedRock логотип"
    routerLink="/"
    class="header__logo"
    height="40"
    width="90"
  />

  <div class="header__menu-wrapper">
    @if (isLoading$ | async) {
      <div class="header__menu-skeleton">
        <div class="header__menu-item-skeleton"></div>
        <div class="header__menu-item-skeleton"></div>
        <div class="header__menu-item-skeleton"></div>
        <div class="header__menu-item-skeleton"></div>
      </div>
    } @else {
      <ng-container *ngTemplateOutlet="mainMenu"></ng-container>
    }
  </div>
</div>

<div class="header__right-wrapper">
  @if (isLoading$ | async) {
    <div class="header__right-skeleton">
      <div class="header__right-skeleton-item"></div>
      <div class="header__right-skeleton-item"></div>
      <div class="header__right-skeleton-item"></div>
    </div>
  } @else {
    @if (userInfo) {
      @if (userInfo?.isAdmin) {
        <lib-button
          class="header__admin-panel-button"
          buttonStyle="secondary"
          (click)="openAdminPanel()">
          {{ 'header.buttons.admin-panel' | translate }}
        </lib-button>
      }

      @if (!deviceDetectionService.isMobile) {
        <rrp-language-selector/>
      }

      <lib-button
        #trigger="libDropdownTrigger"
        buttonStyle="ghost"
        class="header__accounts-button"
        [libDropdownTrigger]="accountMenu"
      >
        {{ userAccount?.label || ('header.buttons.all-accounts' | translate) }}
        <lib-svg-icon
          class="header__dropdown-icon"
          [icon]="trigger.isOpen ? 'arrow-up' : 'arrow-down'"
        />
      </lib-button>

      <lib-icon-button
        #userMenuTrigger="libDropdownTrigger"
        class="header__user-menu-button"
        icon="user"
        [isGlobal]="true"
        [libDropdownTrigger]="userMenu"
        [size]="24"
      >
        <lib-svg-icon
          class="header__dropdown-icon"
          [icon]="userMenuTrigger.isOpen ? 'arrow-up' : 'arrow-down'"
        />
      </lib-icon-button>
    } @else {
      @if (!deviceDetectionService.isMobile) {
        <rrp-language-selector/>
      }

      <lib-button
        buttonStyle="secondary"
        class="header__auth-registration-button"
        (click)="registration()"
      >
        {{ 'header.buttons.registration' | translate }}
      </lib-button>

      <lib-button
        buttonStyle="primary"
        routerLink="/login"
        class="header__auth-login-button"
      >
        {{ 'header.buttons.login' | translate }}
      </lib-button>
    }
  }
</div>

<ng-template #accountMenu>
  <rrp-user-accounts/>
</ng-template>

<ng-template #userMenu>
  <div class="header__user-menu">
    <lib-menu [items]="profileMenuItems"/>
  </div>
</ng-template>

<ng-template #mainMenu>
  <div class="header__menu">
    @for (item of topMenuItems$ | async; track $index) {
      <a
        class="header__menu-item"
        routerLinkActive="active"
        [routerLink]="item.url"
        [routerLinkActiveOptions]="{ exact: item.isExact ?? false }"
      >
        {{ item?.title || (item?.titleTranslateKey ?? '—' | translate) }}
      </a>
    }
  </div>
</ng-template>

<ng-template #mobileMenu>
  <rrp-mobile-menu/>
</ng-template>
